var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A09A",
    fillRule: "nonzero",
    d: "M35.1 0H3.9C1.755 0 0 1.776 0 3.947v22.106C0 28.223 1.755 30 3.9 30h31.2c2.145 0 3.9-1.776 3.9-3.947V3.947C39 1.777 37.245 0 35.1 0zm2.34 24.158l-7.264-8.092a.748.748 0 0 0-1.092-.04.77.77 0 0 0-.039 1.106l8.395 9.355c-.234 1.105-1.209 1.934-2.34 1.934H3.9a2.356 2.356 0 0 1-2.262-1.737l9.048-9.552a.77.77 0 0 0-.039-1.106.748.748 0 0 0-1.092.04L1.56 24.513V8.882l16.341 7.42c.507.237 1.053.316 1.599.316a4.44 4.44 0 0 0 1.599-.315L37.44 8.882v15.276zm0-16.974l-16.965 7.698a2.397 2.397 0 0 1-1.95 0L1.56 7.184V3.947c0-1.302 1.053-2.368 2.34-2.368h31.2c1.287 0 2.34 1.066 2.34 2.368v3.237z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail2);
export default __webpack_public_path__ + "static/media/icon-email2.c795dd64b8cddc107ba74b04b0beaf1d.svg";
export { ForwardRef as ReactComponent };